// Module
var code = "<button ng-show=\"$ctrl.showAddButton\" ng-click=\"$ctrl.addButtonClick()\" class=\"btn btn-primary mt-25\"> Add Tag Group </button> ";
// Exports
export default code;